import { AddressSuggestion, AddressResponse, AdresserResponse, Adresser } from './models';


const urlHandle = (url: string,  params: { [id: string]: string }): string => {
    const urlObj = new URL(url);

    Object.entries(params).forEach(([key, value]) => {
        urlObj.searchParams.append(key, value);
    });

    return urlObj.toString();
}

export function addressFetch(value: string, action: (suggestions: AddressSuggestion[]) => void): void {
    fetch(
        urlHandle(
           'https://adressevaelger.dk/soeg',
            {
                'tekst': value,
                'token': 'adressevaelger123', //At this moment new api don't have user menagment
                'maal': 'adresse',
                'maksimum': '10',
            }
        ),
        {
            method: 'GET',
            headers: {
                'Accept-Encoding': 'gzip, deflate'
            }
        }
    ).then(response => response.json())
    .then(response => {
        const suggestion = response as AddressResponse;
        if(suggestion.status === "ok"){
            action(suggestion.fund);   
        }else {
            console.error(suggestion.beskrivelse);
        }
    })
    .catch(err => console.error('parsing failed', err))
}

export async function addressDetailsFetch(id: string): Promise<Adresser | null> {

    const response = await fetch(
        urlHandle(
           'https://adressevaelger.dk/adresser/' + id,
            {
                'token': 'adressevaelger123', //At this moment new api don't have user menagment
            }
        ),
        {
            method: 'GET',
        }
    );

    if(response.ok){
        const data = await response.json() as AdresserResponse;
        if(data.status === "ok") {
            return data.adresse;
        }
        
        console.error('adressevaelger - wrong data', data.status);
    } 
    else {
        console.error('adressevaelger- wrong response', response.statusText);        
    }

    return null;
}
